import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import './navbar.scss'

const Navbar = () => {

    let location = useLocation();

    const [nav] = useState([
        {
            id: 1,
            path: "/",
            name: "Home"
        },
        {
            id: 2,
            path: "/hotels",
            name: "Hotels"
        },
        {
            id: 3,
            path: "/about",
            name: "About"
        },
        {
            id: 4,
            path: "/product",
            name: "Prduct"
        },
        {
            id: 5,
            path: "/pricing",
            name: "Pricing"
        }
    ]);

    const [navbarCollapse, setNavbarCollapse] = useState(false);

    const renderNavLink = () => {
        return nav.map(link => {
            return (
                <li className={location.pathname === link.path ? "nav-item active" : "nav-item"} key={link.id}>
                    <Link to={link.path} className="nav-link" >{link.name}</Link>
                </li>
            )
        })

    }
    return (
        <nav id="navbar" className="navbar navbar-expand-lg">
            <div className="container">
                <Link to="/home" className="navbar-brand" >
                    <svg width="106" height="30" viewBox="0 0 106 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M25.59 0.019999V23H21.24V12.47L14.04 22.7H13.98L7.05 13.13V23H2.85V0.019999H2.88L14.07 15.89L25.53 0.019999H25.59ZM35.4073 9.89V23H31.2073V9.89H35.4073ZM31.1173 5.24C31.1173 4.64 31.3473 4.14 31.8073 3.74C32.2873 3.32 32.8273 3.11 33.4273 3.11C34.0073 3.11 34.5273 3.32 34.9873 3.74C35.4473 4.14 35.6773 4.64 35.6773 5.24C35.6773 5.84 35.4473 6.34 34.9873 6.74C34.5273 7.14 34.0073 7.34 33.4273 7.34C32.8273 7.34 32.2873 7.14 31.8073 6.74C31.3473 6.34 31.1173 5.84 31.1173 5.24Z" fill="#F087B1" />
                        <path d="M44.4427 12.89C44.8027 12.19 45.2927 11.56 45.9127 11C46.5527 10.44 47.2027 10.01 47.8627 9.71C48.5227 9.39 49.0427 9.23 49.4227 9.23L49.2127 13.43C49.0927 13.41 48.9227 13.4 48.7027 13.4C47.8627 13.4 47.1227 13.62 46.4827 14.06C45.8427 14.5 45.3527 15.07 45.0127 15.77C44.6727 16.45 44.5027 17.15 44.5027 17.87V23H40.3327V9.89H44.1127L44.4427 12.89ZM66.8979 9.89V23H62.6979V21.38C61.4379 22.7 59.9779 23.36 58.3179 23.36C56.3779 23.36 54.7979 22.78 53.5779 21.62C52.3779 20.46 51.7779 18.74 51.7779 16.46C51.7779 15.02 52.0679 13.76 52.6479 12.68C53.2479 11.58 54.0379 10.73 55.0179 10.13C55.9979 9.53 57.0479 9.23 58.1679 9.23C59.3279 9.23 60.2479 9.41 60.9279 9.77C61.6079 10.11 62.2079 10.6 62.7279 11.24L62.9979 9.89H66.8979ZM59.5179 19.94C60.9779 19.94 62.0379 19.28 62.6979 17.96V14.75C62.4579 14.11 62.0379 13.6 61.4379 13.22C60.8579 12.84 60.1679 12.65 59.3679 12.65C58.4479 12.65 57.6579 12.99 56.9979 13.67C56.3579 14.35 56.0379 15.21 56.0379 16.25C56.0379 16.93 56.1979 17.56 56.5179 18.14C56.8379 18.7 57.2579 19.14 57.7779 19.46C58.3179 19.78 58.8979 19.94 59.5179 19.94ZM86.4956 9.89V23C86.4956 24.24 86.1356 25.36 85.4156 26.36C84.7156 27.38 83.7556 28.17 82.5356 28.73C81.3356 29.31 80.0256 29.6 78.6056 29.6C77.5256 29.6 76.5756 29.47 75.7556 29.21C74.9556 28.95 74.3056 28.66 73.8056 28.34C73.3256 28.02 72.7456 27.58 72.0656 27.02L74.5256 24.14C75.1256 24.7 75.7156 25.14 76.2956 25.46C76.8956 25.78 77.6456 25.94 78.5456 25.94C79.6056 25.94 80.4956 25.67 81.2156 25.13C81.9356 24.61 82.2956 23.88 82.2956 22.94V21.08C81.8956 21.76 81.2756 22.31 80.4356 22.73C79.6156 23.15 78.6056 23.36 77.4056 23.36C76.2256 23.36 75.1256 23.06 74.1056 22.46C73.1056 21.84 72.3056 21 71.7056 19.94C71.1056 18.86 70.8056 17.67 70.8056 16.37C70.8056 15.05 71.1156 13.84 71.7356 12.74C72.3756 11.64 73.2056 10.78 74.2256 10.16C75.2656 9.54 76.3556 9.23 77.4956 9.23C78.5756 9.23 79.5356 9.39 80.3756 9.71C81.2156 10.01 81.8556 10.41 82.2956 10.91L82.6256 9.89H86.4956ZM78.6656 19.94C80.3456 19.94 81.5556 19.28 82.2956 17.96V14.75C82.0156 14.11 81.5456 13.6 80.8856 13.22C80.2456 12.84 79.5056 12.65 78.6656 12.65C77.6456 12.65 76.7856 12.99 76.0856 13.67C75.3856 14.35 75.0356 15.21 75.0356 16.25C75.0356 17.29 75.3856 18.17 76.0856 18.89C76.7856 19.59 77.6456 19.94 78.6656 19.94ZM97.95 19.79C98.79 19.79 99.66 19.5 100.56 18.92L102.42 22.04C101.7 22.44 100.94 22.76 100.14 23C99.34 23.24 98.58 23.36 97.86 23.36C96.3 23.36 94.95 23.07 93.81 22.49C92.69 21.89 91.84 21.06 91.26 20C90.68 18.92 90.39 17.69 90.39 16.31C90.39 15.03 90.72 13.85 91.38 12.77C92.06 11.69 92.98 10.84 94.14 10.22C95.3 9.58 96.57 9.26 97.95 9.26C99.83 9.26 101.37 9.81 102.57 10.91C103.79 12.01 104.58 13.58 104.94 15.62L95.34 18.68C95.98 19.42 96.85 19.79 97.95 19.79ZM97.62 12.53C96.68 12.53 95.93 12.85 95.37 13.49C94.81 14.13 94.53 14.99 94.53 16.07V16.34L100.29 14.39C99.87 13.15 98.98 12.53 97.62 12.53Z" fill="#56597A" />
                    </svg>
                </Link>
                <button type="button" className="btn navbar-toggler" onClick={() => setNavbarCollapse(!navbarCollapse)}>
                    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 13H17M1 1H17H1ZM1 7H17H1Z" stroke="#AAAAAB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
                <div className={navbarCollapse ? "collapse navbar-collapse show" : "collapse navbar-collapse"}>
                    <ul className="navbar-nav">
                        {
                            renderNavLink()
                        }
                    </ul>
                </div>
            </div>
        </nav>
    )
}

export default Navbar
